import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { router } from './router';
import { installCrossTabSync } from './stores/ui';
import { isActivityStoreUnavailable } from './lib/api';
import './styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      // An absent activity store does not come back by asking again.
      retry: (failureCount, err) => failureCount < 1 && !isActivityStoreUnavailable(err),
    },
  },
});

// Cross-app + cross-tab BU-selection sync. Listens to `storage` events
// on the `vaultconsent-ui` localStorage key so that when Core (in
// another tab at the same origin) writes a new BU selection, Discovery's
// store rehydrates without a page refresh. Same-tab navigation uses
// Zustand's normal subscribe mechanism.
installCrossTabSync();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster position="top-right" theme="system" richColors closeButton />
    </QueryClientProvider>
  </StrictMode>,
);
